import React from "react"

import globalStyles from "../../../../App.module.scss";
import mandelbrot from './images/mandelbrot.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function MandelbrotSet() {

    let data = `def mandelbrot_escape_time(c: complex, max_iterations: int = 100) -> int:
    z = 0
    for iteration in range(max_iterations):
        z = z * z + c
        if abs(z) > 2:
            return iteration
    return max_iterations


def render(width=80, height=40, max_iterations=50):
    chars = " .:-=+*#%@"
    x_min, x_max = -2.5, 1.0
    y_min, y_max = -1.2, 1.2

    lines = []
    for row in range(height):
        y = y_min + (row / height) * (y_max - y_min)
        line = []
        for col in range(width):
            x = x_min + (col / width) * (x_max - x_min)
            escape_time = mandelbrot_escape_time(complex(x, y), max_iterations)
            shade = chars[min(escape_time, max_iterations - 1) * len(chars) // max_iterations]
            line.append(shade)
        lines.append("".join(line))
    return "\\n".join(lines)


if __name__ == "__main__":
    print(render())
`

    return (
        <div className={globalStyles.article}>
            <h1>Mandelbrot set renderer</h1>
            <p>Renders the Mandelbrot fractal as ASCII art in the terminal. For every character position, it maps
                to a point on the complex plane and repeatedly applies <code>z = z² + c</code>; how many iterations
                it takes for the value to escape (grow past a magnitude of 2) picks the shading character —
                points that never escape (inside the set) stay darkest.</p>
            <p>Pure standard library, no dependencies.</p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>
            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '462px'}}>
                <img src={mandelbrot} alt={""}/>
            </div>
        </div>
    )
}
